import type { DateTime } from "luxon";

export const doDateRangesOverlap = (start1: DateTime, end1: DateTime | null, start2: DateTime, end2: DateTime | null): boolean => {
	const s1 = start1.startOf("day");
	const s2 = start2.startOf("day");
	const e1 = end1?.startOf("day") ?? null;
	const e2 = end2?.startOf("day") ?? null;
	// endDate of null means open-ended ("forever")
	return (e1 === null || e1 >= s2) && (e2 === null || e2 >= s1);
};
